var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{attrs:{"value":_vm.val,"color":_vm.color,"height":"25"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var value = ref.value;
return [_vm._v(" "+_vm._s(_vm.params.value)+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }